import React from 'react'
import songImage from '../../images/news/songs-of-the-week.webp'

const SongsOfTheWeek = () => <img className="playlist-image" src={songImage} loading='lazy'/>

export default SongsOfTheWeek
